<script setup lang="tsx">
import type { JournalFilter } from '@/models/filters-generated'
import JournalTable from './JournalTable.vue'

const props = defineProps<{
	filters: JournalFilter[]
}>()
</script>

<template>
	<JournalTable :filters="props.filters" />
</template>

<style lang="sass" scoped></style>
